import { useEffect } from 'react';

import {
  FooterComponent,
  HeaderComponent,
} from '@/components/BasePages/StandardPage';
import { Carousel } from '@/components/ProductPageBase/Carousel/Carousel';
import EcommOptionsList from '@/components/ProductPageBase/EcommOptionsList/EcommOptionsList';
import EcommStoreProductPageBase from '@/components/ProductPageBase/ProductPageBase';
import AddToCartButton from '@/components/SunrunShop/AddToCartButton/AddToCartButton';
import BuyButton from '@/components/SunrunShop/BuyButton/BuyButton';
import { GlobalFooterContent, GlobalNavContent } from '@/contentful';
import { EcommStoreProductPageEnhancedCF } from '@/contentful/api/types';
import useSunrunShopStore, {
  useSunrunShopActions,
} from '@/data-store/hooks/useSunrunShopStore';
import { userLocationInterface } from '@/hooks/geo';
import { formatUSD } from '@/utils/currency';

import useStyles from './EcommStoreProductPage.styles';
interface Props extends userLocationInterface {
  content: EcommStoreProductPageEnhancedCF;
}

export default function EcommStoreProductPage({
  content,
  userLocation,
  setUserLocation,
}: Props) {
  const { classes } = useStyles();
  const { selectedVariantId } = useSunrunShopStore('selectedVariantId');
  const { setSelectedVariantId } = useSunrunShopActions();

  const { fields } = content;
  const { product, header, footer } = fields;

  const title = product?.title || '';
  const description = product?.description || '';
  const variants = product?.variants?.nodes;
  const images = fields?.product?.images?.nodes?.map((node) => node.url) || [];
  const subheading = fields.subheading;
  const disclaimer = fields.disclaimer;
  const buyNowButtonLabel = fields?.buyNowButtonLabel;
  const addToCartButtonLabel = fields?.addToCartButtonLabel;

  useEffect(() => {
    if (variants?.[0] && !selectedVariantId) {
      setSelectedVariantId(variants[0].id);
    }
  }, [variants, selectedVariantId]);

  const selectedVariant = variants?.find((v) => v.id === selectedVariantId);

  return (
    <>
      <HeaderComponent
        header={header as unknown as GlobalNavContent}
        userLocation={userLocation}
        setUserLocation={setUserLocation}
      />
      <EcommStoreProductPageBase
        heading={title}
        subheading={subheading || ''}
        imageContent={<Carousel images={images} />}
        description={description}
        optionCardLists={[
          <EcommOptionsList
            key='ecomm-options-list'
            variants={variants}
            selectedVariantId={selectedVariantId}
            setSelectedVariantId={setSelectedVariantId}
          />,
        ]}
        totalPrice={
          selectedVariant && formatUSD(selectedVariant.price.amount, 2)
        }
        checkoutButtons={[
          ...(buyNowButtonLabel
            ? [
                <BuyButton
                  key='buy-now'
                  disabled={!selectedVariant}
                  className={classes.buyNowButton}
                  label={buyNowButtonLabel}
                />,
              ]
            : []),
          ...(addToCartButtonLabel
            ? [
                <AddToCartButton
                  key='add-to-cart'
                  disabled={!selectedVariant}
                  className={classes.buyNowButton}
                  label={addToCartButtonLabel}
                />,
              ]
            : []),
        ]}
        disclaimer={disclaimer}
      />
      <FooterComponent
        footer={footer as unknown as GlobalFooterContent}
        userLocation={userLocation}
        setUserLocation={setUserLocation}
      />
    </>
  );
}
